import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Label } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { DefaultRecipientModal } from './DefaultRecipientModal';
import { Item } from './Item';
import { NoRecipientsState } from './NoRecipientsState';
import { OverrideAlert } from './OverrideAlert';
import { TemplateDrawerContent } from '../../../TemplateDrawer';
export function FormContent(props) {
    const { showOverrideAlert } = props;
    const [renderAddModal, setRenderAddModal] = useState(false);
    const [recipientsField, , recipientsHelpers] = useField('recipients');
    const signers = recipientsField.value.filter(({ type }) => type === EsigningRecipientType.Signatory);
    const viewers = recipientsField.value.filter(({ type }) => type === EsigningRecipientType.Viewer);
    const isEmpty = signers.length === 0 && viewers.length === 0;
    const showAddModal = () => setRenderAddModal(true);
    const hideAddModal = () => setRenderAddModal(false);
    const handleAddRecipient = (newRecipient) => {
        recipientsHelpers.setValue([...recipientsField.value, newRecipient]);
        hideAddModal();
    };
    const handleRemoveRecipient = (email) => {
        recipientsHelpers.setValue(recipientsField.value.filter((recipient) => recipient.email !== email));
    };
    const handleEditRecipient = (editedRecipient) => {
        recipientsHelpers.setValue(recipientsField.value.map((recipient) => {
            if (recipient.email === editedRecipient.email) {
                return editedRecipient;
            }
            return recipient;
        }));
    };
    if (isEmpty) {
        return <NoRecipientsState onAddRecipient={handleAddRecipient}/>;
    }
    return (<TemplateDrawerContent>
      {renderAddModal && (<DefaultRecipientModal allRecipients={recipientsField.value} onClose={hideAddModal} onSubmit={handleAddRecipient}/>)}
      <Box flexDirection="column" gap="2xl">
        {showOverrideAlert && <OverrideAlert />}
        {signers.length > 0 && (<Box flexDirection="column" gap="sm">
            <Label>
              <Trans comment="Manage template esigning parties - added signing parties label">
                Added signing parties
              </Trans>
            </Label>
            <Box flexDirection="column" gap="md">
              {signers.map((signer) => (<Item key={signer.email} allRecipients={recipientsField.value} recipient={signer} onRemove={handleRemoveRecipient} onEdit={handleEditRecipient}/>))}
            </Box>
          </Box>)}
        {viewers.length > 0 && (<Box flexDirection="column" gap="sm">
            <Label>
              <Trans comment="Manage template esigning parties - added non signing parties label">
                Added non signing parties
              </Trans>
            </Label>
            <Box flexDirection="column" gap="md">
              {viewers.map((viewer) => (<Item key={viewer.email} allRecipients={recipientsField.value} recipient={viewer} onRemove={handleRemoveRecipient} onEdit={handleEditRecipient}/>))}
            </Box>
          </Box>)}
        <Box justifyContent="center">
          <Button appearance="secondary" size="small" onClick={showAddModal}>
            <Falcon icon="plus"/>
            <Trans comment="Manage template esigning parties - add party button label">Add party</Trans>
          </Button>
        </Box>
      </Box>
    </TemplateDrawerContent>);
}
